// extracted by mini-css-extract-plugin
export default {"box":"index_box_4x73n","rili":"index_rili_n69lM"};